// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__23uUQ","consentsList":"PatientConsents_consentsList__3ONtJ","consentsListEmpty":"PatientConsents_consentsListEmpty__12ZHJ"};